import { render, staticRenderFns } from "./PixList.vue?vue&type=template&id=cfe0f3c0"
import script from "./PixList.vue?vue&type=script&lang=js"
export * from "./PixList.vue?vue&type=script&lang=js"
import style0 from "./PixList.vue?vue&type=style&index=0&id=cfe0f3c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports